@property --angle {
  syntax: '<angle>';
  inherits: true;
  initial-value: 0turn;
}

@property --pos {
  syntax: '<percentage>';
  inherits: true;
  initial-value: 0%;
}

@property --color-1 {
  syntax: '<color>';
  inherits: true;
  initial-value: transparent;
}

@property --color-2 {
  syntax: '<color>';
  inherits: true;
  initial-value: transparent;
}

.grid-title {
  display: grid;
  grid-area: title;
  place-content: center;
  padding-block: calc(var(--mantine-spacing-xs) * 0.25);
  /* margin-block-end: var(--mantine-spacing-xs); */
  font-size: var(--mantine-font-size-xs);
  font-weight: calc(var(--mantine-heading-font-weight) * 0.857);
  /* background: linear-gradient(to bottom, transparent, alpha(var(--mantine-color-dark-5), 0.2)); */
  /* border-block-end: 1px solid alpha(var(--mantine-color-dark-4), 0.5); */
}

.grid-wrapper {
  /* display: contents; */
  &:not(.single-component) {
    /* padding: var(--mantine-spacing-sm); */
    /* border: 1px solid var(--mantine-color-dark-5); */
    /* border-radius: var(--mantine-radius-md); */
    /* box-shadow: var(--mantine-shadow-lg), var(--mantine-shadow-sm); */
  }
  &.single-component {
    .grid-title {
      /* display: none; */
    }
  }
}

.grid-container {
  anchor-name: --grid-container;
  display: grid;
  grid-auto-rows: min-content;
  grid-auto-columns: 1fr;
  gap: var(--mantine-spacing-md);
}

.grid-item {
  anchor-name: --grid-item;
  anchor-scope: all;
  position: relative;
  display: flex;
  justify-content: center;
  container-type: inline-size;
  background: alpha(var(--mantine-color-dark-7), 0.5);
  border-radius: var(--mantine-radius-md);
  &::after {
    --color-1: color-mix(in oklab, transparent, #679cd7ff calc(var(--color-progress, 0.5) * 100%));
    --angle: calc(var(--turn-progress) * 1turn);
    --pos: calc(var(--pos-progress) * 100%);
    position: absolute;
    inset: -2px;
    padding: 1px;
    pointer-events: none;
    content: '';
    background: linear-gradient(var(--angle), var(--color-1) 0%, var(--color-1) var(--pos), var(--color-2) var(--pos));
    border-radius: var(--mantine-radius-sm);
    isolation: isolate;
    mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    mask-composite: exclude;
  }
  /* Layer variant: gradient background with backdrop blur */
  &.layer {
    background: linear-gradient(
      to bottom,
      light-dark(alpha(var(--mantine-color-dark-5), 0.025), alpha(var(--mantine-color-dark-5), 0.3)),
      light-dark(alpha(var(--mantine-color-dark-5), 0.055), alpha(var(--mantine-color-dark-5), 0.1))
    );
    border-radius: var(--mantine-radius-sm);
    /* backdrop-filter: blur(calc(var(--backdrop-blur-radius) * 0.3rem)); */
  }
  /* When caption is on top, switch to column layout */
  &:has(> .caption.top) {
    flex-flow: column nowrap;
  }
}

/* Caption: rotated text sidebar or top header */
.caption {
  --color-1: alpha(var(--mantine-color-dark-3), 0.2);
  --color-2: color-mix(in oklab, transparent, #679cd733 calc(var(--color-progress, 0.5) * 100%));
  --angle: calc(var(--turn-progress) * 1turn);
  --pos: calc(var(--pos-progress) * 100%);
  padding: calc(var(--mantine-spacing-xs) * 0.8);
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: var(--mantine-font-size-xs);
  font-weight: var(--mantine-heading-font-weight);
  text-align: center;
  background: linear-gradient(
    to bottom,
    alpha(var(--mantine-color-dark-3), 0.2),
    alpha(var(--mantine-color-dark-3), 0.1)
  );
  border-start-start-radius: var(--mantine-radius-sm);
  border-start-end-radius: var(--mantine-radius-sm);
  anchor-name: --grid-item-caption;
  anchor-scope: all;
  .caption-text {
    place-content: center;
    padding-inline: var(--mantine-spacing-xs);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &.left {
    width: 2rem;
    background: transparent;
    border-inline-end: 1px solid alpha(var(--mantine-color-dark-3), 0.5);
    .caption-text {
      position: fixed;
      position-anchor: --grid-item-caption;
      left: anchor(left);
      top: calc(anchor(top));
      height: anchor-size(block);
      width: anchor-size(inline);
      writing-mode: vertical-rl;
      transform: rotate(180deg);
    }
  }
  &.top {
    flex: 0 0 auto;
    font-size: var(--mantine-font-size-sm);
  }
}

.item-content {
  position: relative;
  display: grid;
  flex: 1 1 auto;
  container: grid-item-content / inline-size;
  border-radius: inherit;
  &:fullscreen {
    padding: var(--mantine-spacing-lg);
    background: var(--mantine-color-body);
  }
}

:global(.fullscreen-toggle) {
  position: absolute;
  inset: 0;
  z-index: 1;
  display: grid;
  place-content: end;
  padding: calc(var(--mantine-spacing-xs) / 2);
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.1s ease-out;
  .item-content:hover > & {
    border-radius: var(--mantine-radius-sm);
    opacity: 1;
    & > * {
      pointer-events: all;
    }
    &::after {
      --color-1: transparent;
      --color-2: var(--mantine-color-dark-4);
      --angle: 135deg;
      --pos: 50%;
      position: absolute;
      inset: calc(-1 * var(--mantine-spacing-xs) / 2);
      padding: 1px;
      pointer-events: none;
      content: '';
      background: linear-gradient(var(--angle), var(--color-1) 0%, var(--color-1) var(--pos), var(--color-2));
      border-radius: inherit;
      isolation: isolate;
      mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
      mask-composite: exclude;
    }
  }
}

.grid-item-error {
  padding: var(--mantine-spacing-md);
  color: var(--mantine-color-red-6);
}

.error-title {
  font-weight: calc(var(--mantine-heading-font-weight) * 0.857);
}

.error-message {
  margin-top: var(--mantine-spacing-xs);
  font-size: var(--mantine-font-size-sm);
  color: var(--mantine-color-gray-5);
}
